<form nz-form [formGroup]="input.formGroup" nzLayout="horizontal" class="p-4" (keydown.enter)="$event.preventDefault()">
	<div class="modal-body">

		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="label">
				<app-invalid-form-indicator [form]="input.formGroup" field="label" class="me-3"></app-invalid-form-indicator>
				Label
			</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required',minLength: 'Must be at least 1 character',maxLength: 'Cannot exceed 100 characters'}}">
				<input nz-input id="label" formControlName="label" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="description">
				<app-invalid-form-indicator [form]="input.formGroup" field="description" class="me-3"></app-invalid-form-indicator>
				Description
			</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required',minLength: 'Must be at least 1 character',maxLength: 'Cannot exceed 255 characters'}}">
				<input nz-input id="description" formControlName="description" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" >
				<app-invalid-form-indicator [form]="input.formGroup" field="statusIds" class="me-3"></app-invalid-form-indicator>
				Statuses
			</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-select
					nzMode="multiple"
					nzPlaceHolder="Select statuses"
					formControlName="statusIds"
					[nzOptions]="statusOptions">
				</nz-select>
			</nz-form-control>
		</nz-form-item>


		<nz-form-item>
			<nz-form-control [nzOffset]="6" [nzSpan]="14">
				<div class="flex flex-col gap-2">
					<label nz-checkbox formControlName="flagForDuplicateTicket">
						Part of duplicate claim check
					</label>
				</div>
			</nz-form-control>
		</nz-form-item>

		<nz-divider nzText="Dependency"></nz-divider>



	<nz-form-item>
		<nz-form-label [nzSpan]="6" nzFor="dependencyId">
			<app-invalid-form-indicator [form]="input.formGroup" field="dependencyId" class="me-3"></app-invalid-form-indicator>
			Depends On
		</nz-form-label>
		<nz-form-control [nzSpan]="14">
			<nz-select formControlName="dependencyId" id="dependencyId">
				<nz-option [nzValue]="undefined" [nzLabel]="'None'"></nz-option>
				<ng-container *ngFor="let item of getAllElements()">
					<nz-option [nzValue]="item.payload.id" [nzLabel]="item._label"></nz-option>
				</ng-container>
			</nz-select>
		</nz-form-control>
	</nz-form-item>

	<nz-form-item *ngIf="hasDependency">
		<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="dependencyValue">
			<app-invalid-form-indicator [form]="input.formGroup" field="dependencyValue" class="me-3"></app-invalid-form-indicator>
			Expected Value
		</nz-form-label>
		<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
			<input nz-input id="dependencyValue" formControlName="dependencyValue" />
		</nz-form-control>
	</nz-form-item>

	<nz-divider nzText="Settings"></nz-divider>

	<nz-form-item>
		<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="dataType">
			<app-invalid-form-indicator [form]="input.formGroup" field="dataType" class="me-3"></app-invalid-form-indicator>
			Data Type
		</nz-form-label>
		<nz-form-control [nzSpan]="14"  [nzAutoTips]="{en: {required: 'Required'}}">
			<nz-select formControlName="dataType" id="dataType">
				<nz-option *ngFor="let d of dataTypes" [nzValue]="d" [nzLabel]="d"></nz-option>
			</nz-select>
		</nz-form-control>
	</nz-form-item>

	<nz-form-item formArrayName="options" *ngIf="input._dataType == 'DropDownSingle'">
		<nz-form-label [nzSpan]="6" [nzRequired]="true" >
			<app-invalid-form-indicator [form]="input.formGroup" field="options" class="me-3"></app-invalid-form-indicator>
			Options
		</nz-form-label>
		<nz-form-control [nzSpan]="14">
			<div *ngFor="let option of input.options; let i = index" [formGroup]="option.formGroup">
				<div class="row g-1 mb-1">
					<div class="col">
						<input nz-input placeholder="Value" formControlName="value"/>
					</div>
					<div class="col">
						<input nz-input placeholder="Label" formControlName="label"/>
					</div>
					<div class="col">
						<button nz-button nzType="default" nzDanger (click)="removeOption(i)">X</button>
					</div>
				</div>
			</div>
			<button nz-button nzType="dashed" (click)="addOption()">+ Add Option</button>
		</nz-form-control>
	</nz-form-item>


	<nz-form-item>
		<nz-form-label [nzSpan]="6" nzFor="orderIndex" [nzRequired]="true">
			<app-invalid-form-indicator [form]="input.formGroup" field="orderIndex" class="me-3"></app-invalid-form-indicator>
			Display Index
		</nz-form-label>
		<nz-form-control [nzSpan]="14"  [nzAutoTips]="{en: {required: 'Required'}}">
			<input nz-input type="number" placeholder="Index" formControlName="orderIndex" />
		</nz-form-control>
	</nz-form-item>

	<nz-form-item nz-tooltip="Font Awesome 6 (free)">
		<nz-form-label [nzSpan]="6" nzFor="icon">
			<app-invalid-form-indicator [form]="input.formGroup" field="icon" class="me-3"></app-invalid-form-indicator>
			Icon
		</nz-form-label>
		<nz-form-control [nzSpan]="14">
			<nz-input-group [nzSuffix]="suffixIcon">
				<input nz-input type="text" placeholder="Font Awesome icon" formControlName="icon" />
			</nz-input-group>

			<ng-template #suffixIcon>
				<span *ngIf="input._icon">
					Preview:
					<fa-icon *ngIf="input._icon" [icon]="['fas', input._icon]"></fa-icon>
				</span>
			</ng-template>
		</nz-form-control>
	</nz-form-item>

	<nz-divider nzText="Validations"></nz-divider>
	<nz-form-item>
		<nz-form-label [nzSpan]="6">
			<app-invalid-form-indicator [form]="input.formGroup" [fields]="['required','errorMessageRequired']" class="me-3"></app-invalid-form-indicator>
			Required
		</nz-form-label>
		<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required', maxLength: 'Cannot exceed 255 characters'}}">
			<div class="flex flex-col gap-2">
				<label nz-checkbox formControlName="required">
					Required
				</label>
				<input nz-input placeholder="Required error message" formControlName="errorMessageRequired" />
			</div>
		</nz-form-control>
	</nz-form-item>

	<nz-form-item>
		<nz-form-label [nzSpan]="6">
			<app-invalid-form-indicator [form]="input.formGroup" [fields]="['unique','errorMessageUnique']" class="me-3"></app-invalid-form-indicator>
			Unique
		</nz-form-label>
		<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required', maxLength: 'Cannot exceed 255 characters'}}">
			<div class="flex flex-col gap-2">
				<label nz-checkbox formControlName="unique">
					Unique
				</label>
				<input nz-input placeholder="Unique error message" formControlName="errorMessageUnique" />
			</div>
		</nz-form-control>
	</nz-form-item>

	<nz-form-item>
		<nz-form-label [nzSpan]="6">
			<app-invalid-form-indicator [form]="input.formGroup" [fields]="['regex','errorMessageRegex']" class="me-3"></app-invalid-form-indicator>
			Pattern
		</nz-form-label>
		<nz-form-control [nzSpan]="7">
			<input nz-input placeholder="Regex Pattern" formControlName="regex" />
		</nz-form-control>
		<nz-form-control [nzSpan]="7">
			<input nz-input placeholder="Pattern error message" formControlName="errorMessageRegex" />
		</nz-form-control>
	</nz-form-item>


	<nz-form-item>
		<nz-form-label [nzSpan]="6">
			<app-invalid-form-indicator [form]="input.formGroup" [fields]="['minValue','errorMessageMinValue']" class="me-3"></app-invalid-form-indicator>
			Min
		</nz-form-label>
		<nz-form-control [nzSpan]="7"  [nzAutoTips]="{en: {pattern: 'must be a number valid'}}">
			<input nz-input type="number" placeholder="Min" formControlName="minValue" />
		</nz-form-control>
		<nz-form-control [nzSpan]="7">
			<input nz-input placeholder="Min value error" formControlName="errorMessageMinValue" />
		</nz-form-control>
	</nz-form-item>



	<nz-form-item>
		<nz-form-label [nzSpan]="6">
			<app-invalid-form-indicator [form]="input.formGroup" [fields]="['maxValue','errorMessageMaxValue']" class="me-3"></app-invalid-form-indicator>
			Max
		</nz-form-label>
		<nz-form-control [nzSpan]="7"  [nzAutoTips]="{en: {pattern: 'must be a number valid'}}">
			<input nz-input type="number" placeholder="Max" formControlName="maxValue" />
		</nz-form-control>
		<nz-form-control [nzSpan]="7">
			<input nz-input placeholder="Max value error" formControlName="errorMessageMaxValue" />
		</nz-form-control>
	</nz-form-item>

</div>
<div class="modal-footer" style="text-align: right;">
	<nz-form-item>
		<nz-form-control>
			<button class="me-1" nz-button nzType="default" *ngIf="!input.formGroup.valid"  (click)="doClose()">Close</button>
			<button nz-button nzType="primary" *ngIf="input.formGroup.valid" (click)="doClose()">Close</button>
		</nz-form-control>
	</nz-form-item>
</div>

</form>
